import { Theme } from "@mui/material/styles";
import { Box, Button, Chip, Typography } from "@mui/material";
import { Checkbox } from "components/Checkbox";
import ClearIcon from "@mui/icons-material/Clear";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";
import { TPerson, TTeam } from "pages/BehavioralComparison/BehaviouralComparison.types";

interface ISelectedDataListProps {
    type: "users" | "teams";
    someSelected: boolean;
    allSelected: boolean;
    expandSelected: boolean;
    setExpandSelected: React.Dispatch<React.SetStateAction<boolean>>;
    selectedItems?: TPerson[] | TTeam[];
    handleCheckAll: (event: React.ChangeEvent<HTMLInputElement>, type: string) => void;
    handleRemoveAllSelected: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>, type: "users" | "teams") => void;
    handleDeleteSelected: (id: number, type: "users" | "teams") => void;
}

const SelectedDataList = ({
    type,
    someSelected,
    allSelected,
    expandSelected,
    setExpandSelected,
    selectedItems,
    handleCheckAll,
    handleRemoveAllSelected,
    handleDeleteSelected,
}: ISelectedDataListProps) => {
    const selectedItemsCount = selectedItems?.length;

    return (
        <>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center">
                    <Checkbox
                        size="small"
                        sx={(theme: Theme) => ({
                            padding: theme.spacing(0.5),
                            "& > .MuiSvgIcon-root": {
                                fontSize: 14,
                            },
                        })}
                        checked={allSelected}
                        indeterminate={someSelected}
                        onChange={(ev) => handleCheckAll(ev, type)}
                    />
                    <Button
                        size="small"
                        variant="text"
                        sx={(theme: Theme) => ({
                            fontSize: 12,
                            color: theme.palette.secondary.main,
                            textUnderlineOffset: "4px",
                            padding: 0,
                            minWidth: "auto",
                        })}
                        onClick={() => setExpandSelected(!expandSelected)}
                    >
                        <Typography
                            sx={{
                                fontSize: 12,
                                cursor: !selectedItemsCount ? "default" : "pointer",
                                color: !selectedItemsCount ? "text.disabled" : "inherit",
                                textDecoration: !selectedItemsCount ? "none" : "underline",
                            }}
                        >
                            {selectedItemsCount} Selected
                        </Typography>
                    </Button>
                </Box>
                <Button
                    size="small"
                    variant="text"
                    disabled={!selectedItemsCount}
                    sx={(theme: Theme) => ({
                        fontSize: 12,
                        padding: theme.spacing(0, 1, 0, 0),
                        minWidth: "auto",
                        "&.Mui-disabled": {
                            color: theme.palette.text.disabled,
                        },
                        "& .MuiButton-startIcon": {
                            marginRight: theme.spacing(0.5),
                        },
                    })}
                    startIcon={<ClearIcon fontSize="small" />}
                    onClick={(ev) => handleRemoveAllSelected(ev, type)}
                >
                    <Typography fontSize={12}>Clear</Typography>
                </Button>
            </Box>

            {expandSelected && (
                <Box
                    sx={(theme: Theme) => ({
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: theme.spacing(1),
                        maxHeight: 186,
                        overflowY: "scroll",
                    })}
                >
                    {selectedItems?.map((selected) => (
                        <Chip
                            variant="outlined"
                            size="small"
                            key={selected.id}
                            label={selected.name}
                            onDelete={() => handleDeleteSelected(selected.id, type)}
                            deleteIcon={<CustomIcon icon={icons.crossClose} sx={{ color: "neutrals.main" }} />}
                        />
                    ))}
                </Box>
            )}
        </>
    );
};

export default SelectedDataList;
